"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContacts = exports.registerErrorHandlerProvider = exports.registerBearerTokenProvider = exports.registerUrlProvider = void 0;
var getContacts_1 = require("./contacts/functions/getContacts");
var envelope_1 = require("@fuze/apis-core/dist/envelope");
var injectAsyncArguments_1 = require("@fuze/apis-core/dist/injectAsyncArguments");
var provider_1 = require("@fuze/apis-core/dist/provider");
var bearerTokenProvider_1 = require("@fuze/apis-core/dist/bearerTokenProvider");
Object.defineProperty(exports, "registerBearerTokenProvider", { enumerable: true, get: function () { return bearerTokenProvider_1.registerBearerTokenProvider; } });
var errorInterceptorProvider_1 = require("@fuze/apis-core/dist/errorInterceptorProvider");
var _a = (0, provider_1.default)(), registerUrlProvider = _a.registerProvider, getUrl = _a.provideValue;
exports.registerUrlProvider = registerUrlProvider;
var _b = (0, errorInterceptorProvider_1.default)(), registerErrorHandlerProvider = _b.registerErrorHandlerProvider, errorInterceptor = _b.errorInterceptor;
exports.registerErrorHandlerProvider = registerErrorHandlerProvider;
var injectArguments = (0, injectAsyncArguments_1.default)(getUrl, bearerTokenProvider_1.getBearerToken);
var getContacts = function (userIds, organizationCode) {
    return (0, envelope_1.extractDataFromEnvelope)(injectArguments(errorInterceptor(getContacts_1.default)))(userIds, organizationCode);
};
exports.getContacts = getContacts;
